// extracted by mini-css-extract-plugin
export default {"slide":"BannerSlider_slide__seNS9","slider":"BannerSlider_slider__C3OTU","header":"BannerSlider_header__pQz-p","text":"BannerSlider_text__Pf2hg","dots":"BannerSlider_dots__HVq5v"};